"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceViewV3 = void 0;
var WorkspaceViewV3;
(function (WorkspaceViewV3) {
    let Mode;
    (function (Mode) {
        Mode["UNKNOWN"] = "Unknown";
        Mode["PRO"] = "Pro";
        Mode["EXPERT"] = "Expert";
    })(Mode = WorkspaceViewV3.Mode || (WorkspaceViewV3.Mode = {}));
})(WorkspaceViewV3 || (exports.WorkspaceViewV3 = WorkspaceViewV3 = {}));
